import React from "react";

const SvgMidBellGraph = (props) => (
  <svg width={92} height={57} {...props}>
    <defs>
      <linearGradient
        x1="90.441%"
        y1="57.027%"
        x2="12.347%"
        y2="39.632%"
        id="Mid_Bell_Graph_svg__c"
      >
        <stop stopColor="#47CF73" offset="0%" />
        <stop stopColor="#56EC86" offset="100%" />
      </linearGradient>
      <filter
        x="-32.7%"
        y="-39.2%"
        width="165.2%"
        height="248.6%"
        filterUnits="objectBoundingBox"
        id="Mid_Bell_Graph_svg__a"
      >
        <feMorphology
          radius={1.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset dy={12} in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feMorphology radius={1.5} in="SourceAlpha" result="shadowInner" />
        <feOffset dy={12} in="shadowInner" result="shadowInner" />
        <feComposite
          in="shadowOffsetOuter1"
          in2="shadowInner"
          operator="out"
          result="shadowOffsetOuter1"
        />
        <feGaussianBlur
          stdDeviation={5}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.470588235 0 0 0 0 0.564705882 0 0 0 0 0.611764706 0 0 0 0.243716033 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <path
        d="M70 30.496c-4.296-.978-7.486-2.473-9.572-4.485-3.128-3.018-7.673-17.265-15.57-22.636-7.897-5.372-14.138-5.16-22.21 6.759-8.07 11.92-7.476 12.463-11.032 15.877C9.244 28.287 5.373 30.241 0 31.875"
        id="Mid_Bell_Graph_svg__b"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M53.403 36H40.625l-.439-20.389c-.221-3.865-.221-6.668 0-8.41.222-1.742.514-2.21.874-1.406l2.977-1.953 2.974-1.03 2.112.794 1.571.236.862-.558.653 1.392 1.194-.551V36z"
        fill="#47CF73"
        opacity={0.209}
      />
      <g
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(11 2)"
      >
        <use
          fill="#000"
          filter="url(#Mid_Bell_Graph_svg__a)"
          xlinkHref="#Mid_Bell_Graph_svg__b"
        />
        <use
          stroke="url(#Mid_Bell_Graph_svg__c)"
          strokeWidth={3}
          xlinkHref="#Mid_Bell_Graph_svg__b"
        />
      </g>
    </g>
  </svg>
);

export default SvgMidBellGraph;
